<template>
	<div class="exhibitor-file text-decoration-none">
		<a class="d-flex text-decoration-none" :href="file.url" target="_blank">
			<PostAttachments :attachment="file" backgroundColor="#ffffff" />
			<div style="width: 100%" class="d-flex justify-space-between">
				<div class="exhibitor-file__info">
					<p class="exhibitor-file__info-name">
						{{ file.file_real_name }}
					</p>
				</div>
			</div>
		</a>
		<p class="exhibitor-file__info-data mb-0 mt-1">
			{{ fileDate }}
		</p>
	</div>
</template>
<script>
import ResourceFileIcon from '@/components/Resource/ResourceFileIcon'
import PostAttachments from '@/components/Post/PostAttachments.vue'
export default {
	components: {
		PostAttachments,
		ResourceFileIcon,
	},
	props: {
		file: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		fileDate() {
			const date = new Date(this.file.time * 1000)
			const options = { year: 'numeric', month: 'long', day: 'numeric' }
			return date.toLocaleDateString('en-US', options)
		},
	},
}
</script>
<style lang="scss">
.exhibitor-file {
	display: flex;
	flex-direction: column;
	padding: 12px;
	border: 1px solid #e2e2e2;
	background-color: #f3f3f6;
	border-radius: 8px;
	margin-top: 8px;
	text-decoration: none !important;

	&__info {
		margin-left: 8px;

		&-name {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--username-category-title);
			text-decoration: underline;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;
			text-decoration: none;
		}

		&-data {
			color: #9b9b9b;
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 12px;
			line-height: 100%;
			letter-spacing: 0;
		}
	}
}
</style>
